// Named re-exports — `@twisto/environment` ships as CJS source, and
// `export * from` against a CJS module loses the binding in tsup's
// dual ESM/CJS output. Listing the exports explicitly avoids the
// "0 exports at runtime" footgun.
//
// Runtime flags only. Environment *data* (endpoints, ports, keys, tokens,
// realms, flow ids) belongs to each consuming app's own `libs/environment`.
export {
  HEALTHCHECK_PATH,
  IS_CI,
  IS_DEV,
  IS_DEV_RUNTIME,
  IS_PROD,
  IS_PROD_RUNTIME,
  IS_TEST,
  gitRevision,
  isBrowser,
  isDev,
  isProd,
  isTest,
  isTestServer,
} from '@twisto/environment'
